import { useTranslation } from 'react-i18next';
import { ToggleButton } from 'common/components/Inputs/ToggleGroup/ToggleButton';
import { ToggleGroup } from 'common/components/Inputs/ToggleGroup/ToggleGroup';
import { ObjectValues } from 'src/common/tsHelpers';
import { pxToRem } from 'src/common/utils/fonts';

export const UsageType = {
  Data: 'data',
  Voice: 'voice',
  Sms: 'sms',
} as const;
export type UsageTypeValue = ObjectValues<typeof UsageType>;

type UsageTypeSwitchProps = {
  value: string;
  onChange: (value: UsageTypeValue) => void;
};

export const UsageTypeSwitch = ({ value, onChange }: UsageTypeSwitchProps) => {
  const { t } = useTranslation();

  return (
    <ToggleGroup
      value={value}
      onChange={(_event, value) => {
        if (value === null) {
          return;
        }

        onChange(value);
      }}
      data-testid="usage-type-selector"
      aria-label="Select usage type"
      sx={{ height: pxToRem(30), marginBottom: 0 }}
    >
      <ToggleButton value={UsageType.Data} data-testid={'select-usage-type-data'}>
        {t('graphs.usageTypes.data')}
      </ToggleButton>
      <ToggleButton value={UsageType.Voice} data-testid={'select-usage-type-voice'}>
        {t('graphs.usageTypes.voice')}
      </ToggleButton>
      <ToggleButton value={UsageType.Sms} data-testid={'select-usage-type-sms'}>
        {t('graphs.usageTypes.sms')}
      </ToggleButton>
    </ToggleGroup>
  );
};
